import { APINewField } from "@/server/services/tables/types/fields";
import { BlockType } from "@prisma/client";

export const blockType = "checklist-block";
export const blockTypeDbName = BlockType.Checklist;

export const blockTypeToName = {
  [blockType]: blockTypeDbName,
} as const;

export const blockNameToType = {
  [blockTypeDbName]: blockType,
} as const;

export const DEFAULT_CHECKLIST_FIELDS: APINewField[] = [
  {
    name: "Name",
    type: "string",
  },
  {
    name: "Complete",
    type: "boolean",
    options: {
      icon: "formCheckCircleOutlined",
      alignment: "center",
    },
  },
  {
    name: "Status",
    type: "labeled_string",
    options: {
      choice_provider: {
        kind: "static",
        choices: [
          { label: "To Do", value: "To Do", color: "#e8e7e4" },
          { label: "In Progress", value: "In Progress", color: "#d2d8f3" },
          { label: "Done", value: "Done", color: "#b8e6bf" },
        ],
      },
    },
  },
  // TODO: Enhancement: Add due date field, need to specify correct timezone
  // Peter suggests Intl.DateTimeFormat().resolvedOptions().timeZone
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions#timezone
  // {
  //   name: "Due Date",
  //   type: "datetime",
  //   options: {
  //     icon: "actionCalendar",
  //     alignment: "right",
  //     timezone: "America/Los_Angeles"
  //   }
  // }
];

export const MAXIMUM_CHECKLIST_ITEMS = 100;
